import styled from 'styled-components'
import ModelDropdown from './OptionDropdown/ModelDropdown'

export const ModelSection = styled.div`
  display: flex;
  flex-direction: column;
`

export const DropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 11px;
  gap: 12px;
`

export const ModelOptionsWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;

  .quality-dropdown,
  .option-dropdown {
    height: 36px;
  }

  .quality-dropdown {
    flex-basis: 46%;
  }
  .option-dropdown {
    width: auto;
    flex-grow: 1;
    min-width: 0;
  }
`

export const VideoModelDropdown = styled(ModelDropdown)`
  height: 36px;
`
